import { retirerAccents } from './texte';

export const STATUTS = ['pipeline', 'en_cours', 'clos', 'arrete', 'relance'] as const;
export type StatutCode = (typeof STATUTS)[number];

/** Statuts considérés comme actifs (SPEC 4, règle 7). */
export const STATUTS_ACTIFS: readonly StatutCode[] = ['pipeline', 'en_cours', 'relance'];

/** Libellés d'affichage en français. */
export const LIBELLES_STATUT: Record<StatutCode, string> = {
  pipeline: 'Pipeline',
  en_cours: 'En cours',
  clos: 'Clos',
  arrete: 'Arrêté',
  relance: 'Relance',
};

/**
 * Code de statut d'un libellé SharePoint (SPEC 7.2) : sans accents, en minuscules,
 * espaces remplacés par `_`. Renvoie `null` pour tout libellé inconnu.
 */
export function statutCode(libelle: string | null | undefined): StatutCode | null {
  if (libelle == null) return null;
  const code = retirerAccents(libelle).trim().toLowerCase().replace(/\s+/g, '_');
  return (STATUTS as readonly string[]).includes(code) ? (code as StatutCode) : null;
}

export function estActif(code: StatutCode): boolean {
  return STATUTS_ACTIFS.includes(code);
}
